module.exports = __webpack_public_path__ + "img/gh-12205-2.prt.2803cd9e.jpg";